/**
 * @generated SignedSource<<fb9982ce5f592c8cc2b93687e1ef2430>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Law = "IVG" | "KVG" | "MVG" | "ORG" | "UVG" | "VVG";
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type TreatmentReason = "ACCIDENT" | "CONGENITAL_DEFECT" | "MATERNITY" | "PREVENTION" | "SICKNESS";
import { FragmentRefs } from "relay-runtime";
export type BillingAttributeFragment$data = {
  readonly accidentReference: string | null;
  readonly currentGestationWeek: number | null;
  readonly dateOfAccident: any | null;
  readonly id: string;
  readonly isEmployer: boolean | null;
  readonly isNotBillable: boolean;
  readonly isVisualSymptomExamination: boolean | null;
  readonly ivgCaseReference: string | null;
  readonly lawType: Law | null;
  readonly mvgCaseReference: string | null;
  readonly notBillableReason: NotBillableReason | null;
  readonly organisationId: string | null;
  readonly reason: string | null;
  readonly treatmentReason: TreatmentReason | null;
  readonly " $fragmentType": "BillingAttributeFragment";
};
export type BillingAttributeFragment$key = {
  readonly " $data"?: BillingAttributeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BillingAttributeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNotBillable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notBillableReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "treatmentReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVisualSymptomExamination",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentGestationWeek",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organisationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateOfAccident",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accidentReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmployer",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lawType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ivgCaseReference",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mvgCaseReference",
      "storageKey": null
    }
  ],
  "type": "BillingAttribute",
  "abstractKey": null
};

(node as any).hash = "1b162df54874de0da9745a53a0cd3a7f";

export default node;
